

import React, { useState, useEffect, useRef } from "react";
import Management2 from "./Management2";
import { useNavigate } from "react-router-dom";
import Menudatas from "./Menudatas";
import './categories.css';
import "./Style.css";
import './Management2.css';
import ItemUpdates from "./ItemUpdates";
import ItemDiscounts from "./ItemDiscounts"; // Import the new component

function Categories() {
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("first");
  const [subscriptionPlan, setSubscriptionPlan] = useState("basic"); // Default to basic
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [image, setImage] = useState(null);
  const [text, setText] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [editSubItem, setEditSubItem] = React.useState({
    dishId: '',
    subName: '',
    price: '',
    stockQuantity: '',
    image: '',
    parentIndex: null,
    subIndex: null,
  });

  // Get subscription plan from localStorage on component mount
  useEffect(() => {
    const getSubscriptionPlan = () => {
      try {
        const planData = localStorage.getItem("planTypes");
        if (planData) {
          let plans = JSON.parse(planData);

          // Ensure it's always an array
          if (!Array.isArray(plans)) {
            plans = [plans];
          }

          // Normalize to lowercase for comparison
          const normalizedPlans = plans.map(p => p.toLowerCase());

          // Check for available plans (basic, standard, premium)
          let selectedPlan = "basic"; // default
          if (normalizedPlans.includes("premium")) selectedPlan = "premium";
          else if (normalizedPlans.includes("standard")) selectedPlan = "standard";
          else if (normalizedPlans.includes("basic")) selectedPlan = "basic";

          console.log("📦 Subscription plan detected:", selectedPlan);
          setSubscriptionPlan(selectedPlan);
        } else {
          console.warn("⚠️ No subscription plan found in localStorage");
          setSubscriptionPlan("basic");
        }
      } catch (error) {
        console.error("Error parsing subscription plan:", error);
        setSubscriptionPlan("basic");
      }
    };

    getSubscriptionPlan();
  }, []);

  const applyFilter = (allData, vegOnly) => {
    if (vegOnly === null) {
      setFilteredData(allData);
      return;
    }

    const filtered = allData.map(category => {
      const filteredSubcategories = category.subcategories.filter(
        sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
      );

      return {
        ...category,
        subcategories: filteredSubcategories
      };
    }).filter(cat => cat.subcategories.length > 0);

    setFilteredData(filtered);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = () => {
    if (!text || !image) {
      alert("Please fill in all fields.");
      return;
    }
    console.log("Saved category:", text, image);
    setShowPopup(false);
    setImage(null);
    setText("");
  };

  const styles = {
    overlay: {
      position: "fixed",
      top: 0, left: 0,
      width: "100%", height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex", justifyContent: "center", alignItems: "center",
      zIndex: 1000,
    },
    popup: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "10px",
      width: "300px",
      position: "relative",
    },
    input: {
      width: "90%",
      padding: "10px",
      marginTop: "10px",
      fontSize: "16px",
    },
    buttons: {
      textAlign: "center",
      marginTop: "15px",
    },
    saveBtn: {
      padding: "10px 20px",
      backgroundColor: "#4CAF50",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
    }
  };

  // Determine which buttons to show based on subscription plan
  const showItemsUpdateButton = subscriptionPlan === "standard" || subscriptionPlan === "premium";
  const showItemDiscountsButton = subscriptionPlan === "standard" || subscriptionPlan === "premium"; // Only for premium plan

  return (
    <div>
      {/* Tab Headers */}
      <div className="tavheders"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          marginBottom: "1rem",
          gap: "1rem",
        }}
      >
        {/* Left Buttons: Menu, Item Details, Items Update (only for standard/premium), Item Discounts (only for premium) */}
        <div
          className="leftbuttonmenu"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            marginTop: "60px",
            marginBottom: "30px",
            flexDirection: window.innerWidth <= 768 ? "column" : "row",
          }}
        >
          <div
            className="menubutton"
            style={{
              padding: "10px 20px",
              border: "none",
              backgroundColor: "#d9d9d9",
              color: "#000",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "all 0.3s",
              fontWeight: "bold",
              width: window.innerWidth <= 768 ? "300px" : "auto",
              textAlign: "center",
              fontSize: window.innerWidth < 1100 ? "12px" : window.innerWidth < 1200 ? "13px" : "15px",
            }}
            onClick={() => navigate("/menuiteams")}
          >
            Menu
          </div>

          <div
            className="itemdetailsbutton"
            style={{
              padding: "10px 20px",
              border: "none",
              backgroundColor: activeTab === "first" ? "#b15cd6" : "#d9d9d9",
              color: activeTab === "first" ? "white" : "#000",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "all 0.3s",
              fontWeight: "bold",
              boxShadow: activeTab === "first" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
              width: window.innerWidth <= 768 ? "300px" : "auto",
              textAlign: "center",
              fontSize: window.innerWidth < 1100 ? "12px" : window.innerWidth < 1200 ? "13px" : "15px",
            }}
            onClick={() => setActiveTab("first")}
          >
            Item Details
          </div>

          {/* Items Update Button - Only show for standard and premium plans */}
          {showItemsUpdateButton && (
            <div
              className="itemsupdatebutton"
              style={{
                padding: "10px 20px",
                border: "none",
                backgroundColor: activeTab === "second" ? "#b15cd6" : "#d9d9d9",
                color: activeTab === "second" ? "white" : "#000",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "all 0.3s",
                fontWeight: "bold",
                boxShadow: activeTab === "second" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
                width: window.innerWidth <= 768 ? "300px" : "auto",
                textAlign: "center",
                fontSize: window.innerWidth < 1100 ? "12px" : window.innerWidth < 1200 ? "13px" : "15px",
              }}
              onClick={() => setActiveTab("second")}
            >
              Item Update
            </div>
          )}

          {/* Item Discounts Button - Only show for premium plan */}
          {showItemDiscountsButton && (
            <div
              className="itemdiscountsbutton"
              style={{
                padding: "10px 20px",
                border: "none",
                backgroundColor: activeTab === "third" ? "#b15cd6" : "#d9d9d9",
                color: activeTab === "third" ? "white" : "#000",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "all 0.3s",
                fontWeight: "bold",
                boxShadow: activeTab === "third" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
                width: window.innerWidth <= 768 ? "300px" : "auto",
                textAlign: "center",
                fontSize: window.innerWidth < 1100 ? "12px" : window.innerWidth < 1200 ? "13px" : "15px",
              }}
              onClick={() => setActiveTab("third")}
            >
              Item Discount
            </div>
          )}

          {showPopup && (
            <div style={styles.overlay}>
              <div style={styles.popup}>
                <div
                  style={{
                    position: 'absolute',
                    fontSize: '20px',
                    cursor: 'pointer',
                    color: '#888',
                    fontWeight: 'bold',
                    marginLeft: "243px",
                    marginTop: "-18px"
                  }}
                  onClick={() => setShowPopup(false)}
                >
                  ×
                </div>
                <h3>Add Item</h3>
                <div
                  style={{
                    width: '141px',
                    height: '123px',
                    border: '2px dashed #aaa',
                    borderRadius: '8px',
                    margin: '10px auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    backgroundColor: '#f9f9f9',
                    overflow: 'hidden',
                  }}
                  onClick={() => document.getElementById('hiddenFileInput').click()}
                >
                  {image ? (
                    <img
                      src={image}
                      alt="Preview"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <div style={{ fontSize: '40px', color: '#bbb', fontWeight: 'bold' }}>+</div>
                  )}
                </div>
                <input
                  id="hiddenFileInput"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: 'none' }}
                />
                <input
                  type="text"
                  placeholder="Enter Category"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  style={styles.input}
                />
                <div style={styles.buttons}>
                  <button onClick={handleSave} style={styles.saveBtn}>Save</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === "first" && <Management2 plan={subscriptionPlan} />}
        {activeTab === "second" && showItemsUpdateButton && (
          <ItemUpdates />
        )}
        {activeTab === "third" && showItemDiscountsButton && (
          <ItemDiscounts />
        )}
        {/* Note: The old "third" tab (Menudatas) would now be "fourth" if you still need it */}
        {activeTab === "fourth" && <Menudatas />}
      </div>
    </div>
  );
}

export default Categories;